<template>
  <el-dialog :visible.sync="dialogVisible" @close='closeDialog' width="300px" :title="dialogStatus ? '确认用户信息' : '请输入查询信息'">
    <div style="display: flex; flex-direction: column; align-items: center">
      <el-input v-model="agentNickname" v-if="!dialogStatus" placeholder="请输入微信昵称" class="padding width-200"></el-input>
      <el-input v-model="agentPhone" v-if="!dialogStatus" placeholder="请输入电话号码" class="padding width-200"></el-input>
      <div v-else style="display: flex; justify-content: space-around; align-items: center; width: 80%; padding-bottom: 20px;">
        <div>{{agentInfo.client_id}}</div>
        <div style="display: flex; max-width: 120px; align-items: center">
          <img style="width:50px;height:50px;" :src="agentInfo.avatar_url">{{agentInfo.nickname}}
        </div>
      </div>
      <div>
        <el-button
          type="primary"
          @click="clickDialogButton"
          :loading="dialogButtonLoading"
          :disabled="!this.agentNickname && !this.agentPhone">
          {{dialogStatus ? '确认添加' : '查找'}}
        </el-button>
        <el-button v-if="dialogStatus" @click="resetDialogInfo">返回</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogModal',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      agentNickname: undefined,
      agentPhone: undefined,
      dialogStatus: false,
      searchUserUrl: this.getDomain() + 'bmagent/search_client', // 查询想成为代理商的
      becomeAgentUrl: this.getDomain() + 'bmagent/set_agent', // 成为代理商
      agentInfo: {}
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    clickDialogButton () {
      if (this.dialogStatus) {
        this.becomeBrander()
      } else {
        this.searchUser()
      }
    },
    becomeBrander () {
      let params = {
        client_id: this.agentInfo.client_id
      }
      let handle = () => {
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.$emit('getList')
      }
      this.__axios(this.becomeAgentUrl, params, handle)
    },
    searchUser () {
      let params = {
        nickname: this.agentNickname || '',
        phone: this.agentPhone || ''
      }
      let handle = res => {
        if (!res.data.content.client_list.length) {
          this.$message.error('不存在此用户')
        } else if (res.data.content.client_list.length > 1) {
          this.$message.error('搜到多个用户，请换条件重试')
        } else {
          this.agentInfo = res.data.content.client_list[0]
          this.dialogStatus = true
        }
      }
      this.__axios(this.searchUserUrl, params, handle)
    },
    resetDialogInfo () {
      this.dialogStatus = false
    },
    closeDialog () {
      this.dialogStatus = false
      this.agentNickname = ''
      this.agentPhone = ''
    }
  }
}
</script>

<style scoped>

  .padding {
    padding: 10px;
  }

  .width-200 {
    width: 200px;
  }
</style>
